import renderInputField from 'components/FormControls/textInput'
import { Button, Grid } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Field, Form, reduxForm } from 'redux-form'
import validator from 'utils/asyncValidator'
import shouldAsyncValidate from 'utils/shouldAsyncValidate'
import { onlyNumbers } from 'utils/normalize/onlyNumbers'
import { TWO_FACTOR } from 'modules/Auth/types'
import { validationSchema } from 'modules/Forms/Auth/DoubleFA/validationSchema'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

let DoubleFAForm = ({ handleSubmit, submitting, form, onCancel }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const breakpoint = useBreakpoint()
  const submit = async (values) =>
    new Promise((resolve, reject) => {
      dispatch({
        meta: { resolve, reject },
        type: TWO_FACTOR,
        payload: {
          data: { ...values },
          formName: form,
        },
      })
    })

  return (
    <Form onSubmit={handleSubmit(submit)}>
      <div className={'margin-bottom-40'}>
        <Field
          fullWidth
          name="code"
          type="text"
          inputMode="numeric"
          component={renderInputField}
          normalize={onlyNumbers}
          maxLength={6}
          autoComplete="off"
          cleanButton
          t={t}
          label={t('auth::forms.2fa.fields.code.label')}
        />
      </div>

      <Grid
        direction={breakpoint.fbs ? 'column-reverse' : 'row'}
        alignItems={'center'}
        justifyContent={'start'}
        wrap={false}
        gap={16}
      >
        <Button
          fullWidth
          disabled={submitting}
          variant={'ghost'}
          grey
          size="l"
          type="button"
          onClick={onCancel}
        >
          {t('common::form_buttons.cancel')}
        </Button>
        <Button
          fullWidth
          disabled={submitting}
          size="l"
          variant="primary"
          type="submit"
        >
          {t('common::form_buttons.login')}
        </Button>
      </Grid>
    </Form>
  )
}

DoubleFAForm = reduxForm({
  form: 'DoubleFAForm',
  updateUnregisteredFields: true,
  enableReinitialize: true,
  initialValues: {
    code: '',
  },
  shouldAsyncValidate: shouldAsyncValidate,
  asyncValidate: validator(validationSchema),
})(DoubleFAForm)

DoubleFAForm.propTypes = {
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  form: PropTypes.string,
  onCancel: PropTypes.func,
}

DoubleFAForm.defaultValues = {
  handleSubmit: () => {},
  submitting: false,
  form: 'DoubleFAForm',
  onCancel: () => {},
}

export default DoubleFAForm
